import * as React from 'react';
import styled from 'styled-components';
import { DropdownItem } from './DropdownItem';
import { IOptionItem } from '../interfaces/IDropDownItem';
import { dropdownItemsTheme, dropdownBackgroundTheme } from '../theme/default-theme';

export interface IDropdownItems {
    items: IOptionItem[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getItemProps: any;
    highlightedIndex: number | null;
    useDropup?: boolean;
    getMenuProps(): void;
    activeItem?: IOptionItem;
}

const OptionsWrapper = styled.div`
    z-index: 2;
    position: relative;
`;

const OptionsList = styled.ul`
    max-height: 200px;
    overflow-y: auto;
    position: absolute;
    left: 0;
    right: 0;
    margin-top: -1px;
    border: 1px solid;
    list-style: none;
    ${dropdownItemsTheme};
    ${dropdownBackgroundTheme};
    ${(props: { useDropup?: boolean }) => props.useDropup && 'bottom: 40px;'};
    padding-inline-start: 0;
`;

export const DropdownItems = React.forwardRef(
    (
        {
            items,
            getItemProps,
            highlightedIndex,
            activeItem,
            useDropup,
            getMenuProps
        }: IDropdownItems,
        ref: React.RefObject<HTMLDivElement>
    ) => (
        <OptionsWrapper className={'elc-dropdown-options js-dropdown-options'}>
            <div ref={ref}>
                <OptionsList
                    useDropup={useDropup}
                    className={'elc-dropdown-options-list js-dropdown-options-list'}
                    role="listbox"
                    {...getMenuProps()}
                >
                    {items.map((item: IOptionItem, index: number) => (
                        <DropdownItem
                            {...getItemProps({
                                item: item.value
                            })}
                            item={item}
                            key={item.value}
                            isSelectedItem={highlightedIndex === index}
                            isActiveItem={activeItem === item}
                        />
                    ))}
                </OptionsList>
            </div>
        </OptionsWrapper>
    )
);
